import React from 'react';
import { Button } from '@mui/material';
import { Icon } from '@livable/saas-react-components';
import useStyles from './billBatchFilterBannerStyles';

/**
 * Shown when the Bills list is scoped to one acquisition event (LB-5828). The batch-summary
 * notification's "Review bills" CTA lands on `/bills?batchId={id}`, and this makes plain that the
 * list is filtered to just that email or upload — the ~12 files the email was about, not the whole
 * company — with one click back to every bill.
 */
export const BillBatchFilterBanner = _ref => {
  let count = _ref.count,
    onClear = _ref.onClear;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.banner
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "filter"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.bannerText
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.title
  }, "Showing ", count, " ", count === 1 ? 'bill' : 'bills', " from one email or upload"), /*#__PURE__*/React.createElement("span", {
    className: classes.hint
  }, "These arrived together. Clear the filter to see every bill.")), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: onClear,
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      type: "close"
    })
  }, "Show all bills"));
};